import { render, staticRenderFns } from "./ReCreateStatements.vue?vue&type=template&id=e0c4be10&"
import script from "./ReCreateStatements.vue?vue&type=script&lang=js&"
export * from "./ReCreateStatements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports